import { InquiriesFiltersVisibility } from "~/contexts/InquiriesFiltersContext";
import { IS_TJPR_TEMPLATE } from "./constants";
import { generateRoutePath } from "./generate-route-path";

interface GetDefaultPageRouteOptions {
  locale?: string;
  agentId?: string;
  isExternal?: boolean;
}

export function getDefaultPageRoute({
  locale,
  agentId,
  isExternal,
}: GetDefaultPageRouteOptions = {}): string {
  if (isExternal) {
    return generateRoutePath("external.inquiries", { locale });
  }

  if (agentId) {
    return generateRoutePath("agents.show", {
      locale,
      params: {
        agentId,
      },
    });
  }

  if (IS_TJPR_TEMPLATE) {
    return generateRoutePath("inquiries", {
      locale,
      query: {
        page: "1",
        filters: JSON.stringify({
          name: "",
          visibilityFilter: InquiriesFiltersVisibility.OnlyMine,
        }),
      },
    });
  }

  return generateRoutePath("menu", { locale });
}
